export const installments = {
    isExternalPlanManagementAllowed: false,
    cardMenuItemTranslationKey: 'account.main.installments',
    overviewItemTranslationKey: 'cards.components.installments.overview.charged',
    overviewItemCardTranslationKey: 'cards.components.installments.overview.charged',
    showBonusInterestRates: false,
};
